import { render, staticRenderFns } from "./MainPageScreenshotGallery.vue?vue&type=template&id=78b268fe&"
import script from "./MainPageScreenshotGallery.vue?vue&type=script&lang=js&"
export * from "./MainPageScreenshotGallery.vue?vue&type=script&lang=js&"
import style0 from "./MainPageScreenshotGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports